import React from 'react';
// import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import AfitdAutocompleteLite from './AfitdAutocompleteLite';
import { getSalaryRangeList } from '../lovHelper';
import { numberWithCommas } from '../textHelper';

// import { withStyles } from '@material-ui/core/styles';
// import cx from 'clsx';
// import _map from 'lodash/map';
import _isNaN from 'lodash/isNaN';
import _toNumber from 'lodash/toNumber';
// import _isArray from 'lodash/isArray';
// import _isNil from 'lodash/isNil';
// import _isEmpty from 'lodash/isEmpty';

// const styles = theme => ({
// });

const defaultCurrencySymbol = '$';

// const defaultStyle = { width: '100%', padding: 0, margin: 0 };
// const defaultFilter = createFilterOptions(); //createFilterOptions({ limit: 10 });
const getOptionLabel = option => {
    const salaryRangeInt = _isNaN(option) ? 0 : _toNumber(option);
    return salaryRangeInt === 0 ? 'Any' : `${defaultCurrencySymbol}${numberWithCommas(salaryRangeInt)}+`;
};

const AfitdSalaryRangeAutocomplete = props => {
    return <AfitdAutocompleteLite {...props} options={getSalaryRangeList()} getOptionLabel={getOptionLabel} />;
};

export default AfitdSalaryRangeAutocomplete;
// export default withStyles(styles)(AfitdSalaryRangeAutocomplete);
